const riot = require('riot');

riot.tag2('atom-badge', '<div class="f fh h20 px7 rounded-full border border-transparent ts-pxs-bold {opts.classes}"> <div>{opts.text}</div> </div>', 'atom-badge,[data-is="atom-badge"]{display:inline-block}', '', function(opts) {
});